const LocationRoutes = [
  {
    path: '/locations/distribution_centers',
    component: () => import('@/components/default'),
    children: [
      {
        path: '',
        name: 'distribution_centers',
        component: () =>
          import('@/components/locations/distroCenters/DistroCenters'),
      },
      {
        path: 'single/:distroId',
        name: 'SingleDistro',
        component: () =>
          import('@/components/locations/distroCenters/SingleDistroCenter'),
      },
      {
        path: 'single/stocks_count/:stockId',
        name: 'SingleStockCount',
        component: () =>
          import('@/components/locations/distroCenters/SingleStockCounts'),
      },
    ],
  },
];

export default LocationRoutes;
